export default __webpack_public_path__ + "assets/images/968808cd6cb4ef6e53193f2a1f37eac6.png";